import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col } from "react-bootstrap";
import Breadcrumbs from "../../../../shared/components/Breadcrumbs";
import { ERROR_LOG } from "../../../../shared/constants/Constants";
import ServerSideGrid from "../../../../shared/components/listview/ServerSideGrid";
import { loadTicketErrorLogGetDataRequest } from "../../../ticketing/ticketing/redux/Actions";

const columnDefs = [
  { headerName: "Log ID",        field: "error_log_id",     width: 80,  hide: true },
  {
    headerName: "Ticket ID",
    field: "ticket_id",
    width: 140,
    pinned: true,
    cellRenderer: (params) =>
      params.value ? (
        <a href={`/ticketing/${params.value}`}>{params.value}</a>
      ) : null,
  },
  { headerName: "Error Type",    field: "error_type",       width: 150 },
  { headerName: "Error Code",    field: "error_code",       width: 130 },
  { headerName: "Error Message", field: "error_message",    width: 250 },
  { headerName: "Employee",      field: "employee_id",      width: 130 },
  { headerName: "Endpoint",      field: "endpoint",         width: 220 },
  { headerName: "Method",        field: "http_method",      width: 80  },
  { headerName: "Status Code",   field: "http_status_code", width: 100 },
  { headerName: "Source",        field: "source_page",      width: 160 },
  { headerName: "Environment",   field: "environment",      width: 120 },
  { headerName: "Issue Status",  field: "issue_status",     width: 120, filter: 'agSetColumnFilter' },
  { headerName: "Created On",    field: "created_on",       width: 180, filter: "agDateColumnFilter" },
  { headerName: "Comments",      field: "comments",         width: 200 },
];

const TicketErrorLog = () => {
  const dispatch = useDispatch();
  const { errorLogs, loading } = useSelector((state) => state.ticketing);

  useEffect(() => {
    dispatch(loadTicketErrorLogGetDataRequest());
  }, [dispatch]);

  return (
    <>
      <Row className="detailsPageHeader">
        <Col>
          <Breadcrumbs children={[{ href: "/ticketerrorlog/", label: ERROR_LOG }]} />
        </Col>
      </Row>
      <Row>
      <Card className="table-card">
        <Card.Body>
          <ServerSideGrid
            clientSide={true}
            columnDefs={columnDefs}
            rowData={errorLogs.data}
            loading={loading}
            paginationPageSize={80}
            defaultColDef={{ filter: 'agTextColumnFilter' }}
          />
        </Card.Body>
      </Card>
      </Row>
    </>
  );
};

export default TicketErrorLog;